// extracted by mini-css-extract-plugin
module.exports = {"topBar":"TopBar_topBar__1BUGX","notificationSpacer":"TopBar_notificationSpacer__25rJy"};